import React, { Fragment, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';

import { Tab } from '@headlessui/react';
import cs from 'classnames';

export default function Appointments(props) {
  const [upcomingCounter, setUpcomingCounter] = useState(0);
  const [pastCounter, setPastCounter] = useState(0);
  const outletContext = useOutletContext();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(pathname.includes('upcoming') ? 0 : 1);
  const [tabsData, setTabsData] = useState([
    {
      label: `Upcoming (${upcomingCounter})`,
      path: 'upcoming',
      end: true
    },
    {
      label: `Past (${pastCounter})`,
      path: 'past'
    }
  ]);

  const { patient } = props?.patient ? props : outletContext;

  useEffect(() => {
    const copyArr = [...tabsData];
    copyArr[0] = { ...copyArr[0], label: `Upcoming (${upcomingCounter})` };
    copyArr[1] = { ...copyArr[1], label: `Past (${pastCounter})` };
    setTabsData(copyArr);
  }, [upcomingCounter, pastCounter]);

  const handleTabChange = (index) => {
    setActiveTab(index);
    navigate(
      index === 0
        ? `/portal/charts/${patient?.id}/appointments/upcoming`
        : `/portal/charts/${patient?.id}/appointments/past`
    );
  };

  return (
    <>
      <Tab.Group selectedIndex={activeTab} onChange={handleTabChange}>
        <Tab.List className="!mb-5 flex border-x-0 border-b border-t-0 border-solid border-neutral-200">
          {tabsData.map((tab, i) => {
            return (
              <Tab as={Fragment} key={i} data-qa={tab.label} data-intercom-target={tab.label}>
                {({ selected }) => (
                  <button
                    className={cs(
                      'flex items-center gap-1 border-x-0 border-b-2 border-t-0 border-solid border-transparent !px-4 !py-2 text-sm leading-5',
                      selected
                        ? ' !border-primary-500 font-600 text-primary-500'
                        : 'cursor-pointer font-500 text-neutral-800'
                    )}>
                    {tab.label}
                  </button>
                )}
              </Tab>
            );
          })}
        </Tab.List>
        <Tab.Panels>
          {tabsData.map((tab, i) => (
            <Tab.Panel key={i}>
              {({ selected }) => {
                return selected ? tab.content : null;
              }}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
      <Outlet
        context={{ setUpcomingCounter, setPastCounter, patient, upcomingCounter, pastCounter }}
      />
    </>
  );
}
